import { Redirect, router } from 'expo-router';
import { ScreenContainer, YStack } from 'smoothie';

import UpgradeCheckoutPaymentSheet from '../../../billing/components/UpgradeCheckoutPaymentSheet';

// Throwaway POC screen: spikes Stripe's prebuilt PaymentSheet as an
// alternative to UpgradeCheckout's inline card form. See
// UpgradeCheckoutPaymentSheet.native.tsx for the known limitation.
export default function UpgradeCheckoutPaymentSheetPage() {
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <ScreenContainer
            title="Premium Membership (PaymentSheet)"
            hasBackButton
            onFallbackRoute="/dev/stripe/upgrade-comparison"
        >
            <YStack gap={16} padding={16} width="100%">
                <UpgradeCheckoutPaymentSheet
                    onSuccess={() => {
                        router.replace('/dev/stripe/upgrade-success');
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
}
